// pages/admin/AdminShopSlotUsagePage.jsx
import { useEffect, useState } from 'react'
import { Table, DatePicker, Input, Button, Space, Card, Tag } from 'antd'
import dayjs from 'dayjs'
import axios from 'axios'
import { numberWithCommas } from '@/utils/string'
import { ColumnType } from 'antd/es/table'

const { RangePicker } = DatePicker

export default function AdminShopSlotUsagePage() {
  const [loading, setLoading] = useState(false)

  const [list, setList] = useState([])

  const [shopIds, setShopIds] = useState('')
  const [dateRange, setDateRange] = useState(null)
  const [searchWord, setSearchWord] = useState('')
  const fetchList = async () => {
    setLoading(true)

    try {
      const res = await axios.get('/api/admin/shops/slot-usage', {
        params: {
          shopIds: shopIds || undefined,
          searchWord,
          startDate: dateRange?.[0]?.format('YYYY-MM-DD'),
          endDate: dateRange?.[1]?.format('YYYY-MM-DD'),
        },
      })

      setList(res.data.data || [])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchList()
  }, [dateRange])

  const columns: any = [
    {
      title: '업체명',
      dataIndex: 'shopName',
      fixed: 'left',
      width: 180,
    },
    {
      title: '업체코드',
      dataIndex: 'shopCode',
      width: 120,
      render: v => v || '-',
    },
    {
      title: '상태',
      dataIndex: 'activeYn',
      width: 90,
      render: v => v === 1 ? <Tag color="blue">활성</Tag> : <Tag>비활성</Tag>,
    },
    {
      title: '전체 슬롯',
      dataIndex: 'totalSlotCount',
      width: 110,
      align: 'center',
      sorter: (a, b) => a.totalSlotCount - b.totalSlotCount,
      render: (v, record) => {
        return numberWithCommas(v)
      }
    },
    {
      title: '오픈 슬롯',
      dataIndex: 'openSlotCount',
      width: 110,
      align: 'center',
      sorter: (a, b) => a.openSlotCount - b.openSlotCount,
      render: (v, record) => {
        return numberWithCommas(v)
      }
    },
    {
      title: '예약 슬롯',
      dataIndex: 'bookedSlotCount',
      width: 110,
      align: 'center',
      sorter: (a, b) => a.bookedSlotCount - b.bookedSlotCount,
      render: (v, record) => {
        return numberWithCommas(v)
      }
    },
    {
      title: '예약률',
      dataIndex: 'bookedRate',
      width: 110,
      sorter: (a, b) => a.bookedRate - b.bookedRate,
      render: v => `${v}%`,
    },
    {
      title: '주소',
      dataIndex: 'address',
      render: v => v || '-',
    },
  ]
  return (
    <Card title="업체별 슬롯 사용 현황">
      <Space style={{ marginBottom: 16 }}>
        <form 
          style={{ display: 'flex', gap: 8 }} 
          onSubmit={e => {
            e.preventDefault()
            fetchList()
          }}
        >
          
          <Input
            placeholder="업체 이름 검색"
            value={searchWord}
            onChange={e => setSearchWord(e.target.value)}
            style={{ width: 180 }}
          />

          <RangePicker
            value={dateRange}
            onChange={setDateRange}
            placeholder={['시작일', '종료일']}
            defaultPickerValue={[dayjs('2026-10-01', 'YYYY-MM-DD'), dayjs('2026-10-31', 'YYYY-MM-DD')]}
            defaultValue={[dayjs('2026-10-01', 'YYYY-MM-DD'), dayjs('2026-10-31', 'YYYY-MM-DD')]}
          />

          <Button type="primary" htmlType="submit" onClick={fetchList}>
            조회
          </Button>
        </form>
      </Space>

      <Table
        rowKey="shopId"
        loading={loading}
        columns={columns}
        dataSource={list}
        pagination={{
          pageSize: 30,
          showSizeChanger: true,
        }}
        scroll={{ x: 1000 }}
      />
    </Card>
  )
}